import React from 'react';

const Contact = () => {
    const styles = {textAlign: 'center'};
    return (
        <div>
            <h2 style={styles}>This is Contact</h2>
        </div>
    );
};

export default Contact;